import { Spacer } from '@cellula/react';
import { FlexibleSpacerModel } from '@services/flexible_component/mod';
import { rem } from '@visiba/std';

interface Props {
	component: FlexibleSpacerModel;
}

const spacerValueMap = new Map<string, string>([
	['XSmall', rem(8)],
	['Small', rem(16)],
	['Medium', rem(32)],
	['Large', rem(64)],
	['XLarge', rem(128)],
]);

export function FlexibleSpacer({ component }: Props): JSX.Element {
	return (
		<Spacer
			data-testid='FlexibleSpacer'
			vertical={spacerValueMap.get(component.vertical)}
			horizontal={spacerValueMap.get(component.horizontal)}
		></Spacer>
	);
}
